import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/friends/page.tsx");
